import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "./LogMessage.css";

const EMAIL_PATTERN = /^[\w.+-]+@[\w-]+(?:\.[\w-]+)+$/;
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const TOKEN_PATTERN = /([\w.+-]+@[\w-]+(?:\.[\w-]+)+|'[^']*'|\[[^\]]*\])/g;

// Splits a log message into "who" (the acting user's email), "what" (quoted
// values changed, plus any other email caught up in the action, e.g. the
// deleted user's address), bracketed entity references ([Criteria name],
// [conversation-call-id]) and plain connecting text, each styled
// differently so a long sentence stays scannable. A bracketed conversation
// call id (a uuid) becomes a link that opens the conversation profile in a
// new tab; a bracketed criteria name is just highlighted, not clickable.
function LogMessage({ message = "", viewerEmail = null }) {
    if (!message) return null;

    const parts = message.split(TOKEN_PATTERN);
    let sawFirstEmail = false;

    const content = parts.map((part, i) => {
        if (!part) return null;

        if (EMAIL_PATTERN.test(part)) {
            const isWho = !sawFirstEmail;
            sawFirstEmail = true;
            // In a personal "my activity" feed the actor is always the
            // viewer themselves — showing their own email on every single
            // line is noisy, so swap it for "You" there.
            const isViewer = isWho && viewerEmail && part.toLowerCase() === viewerEmail.toLowerCase();
            return (
                <span key={i} className={isWho ? "log-message_who" : "log-message_what"}>
                    {isViewer ? "You" : part}
                </span>
            );
        }

        if (part.startsWith("'") && part.endsWith("'")) {
            return <span key={i} className="log-message_what">{part}</span>;
        }

        if (part.startsWith("[") && part.endsWith("]")) {
            const inner = part.slice(1, -1);
            if (UUID_PATTERN.test(inner)) {
                return (
                    <a
                        key={i}
                        className="log-message_conversation"
                        href={`/supervision/conversation/profil/${inner}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                    >
                        [{inner}]
                    </a>
                );
            }
            return <span key={i} className="log-message_entity">{part}</span>;
        }

        return <span key={i}>{part}</span>;
    });

    return (
        <Tippy
            content={<div className="log-message_tooltip">{message}</div>}
            placement="top"
            delay={[300, 0]}
        >
            <span className="log-message">{content}</span>
        </Tippy>
    );
}

export default LogMessage;
